import { Logger } from 'logger';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { styled } from '../../assets/theme';

const debugLog = Logger.create('Modal:index.tsx')

interface IModalProps {
  title: string,
  shouldShow: boolean,
  children: any,
  onDismiss?: () => void
}

export const Modal: React.FunctionComponent<IModalProps> = ({shouldShow, title, children, onDismiss}) => {
  const [container] = useState(() => {
    debugLog('Modal created')
    return document.createElement('div')})

  const onDismissClick = () => {
    if (onDismiss) {
      onDismiss();
    }
  }

  useEffect(() => {
    const modalRoot = document.getElementById('modal-root');
    if (modalRoot) {
      modalRoot.appendChild(container);
      return () => { modalRoot.removeChild(container) }
    }
    return () => null
  }, [container])

  if (!shouldShow) { return <div /> };

  return (
    ReactDOM.createPortal(
    <ModalContainer id="find-me">
      <ModalOverlay onClick={onDismissClick} />
      <ModalPanel>
        {title && <Header>{title}</Header>}
        <Body>{children}</Body>
      </ModalPanel>
    </ModalContainer>,
    container)
  );
}

const ModalContainer = styled.div`
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
`;

const ModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  opacity: 0.75;

  background: ${({ theme }) => theme.overlay.backgroundColor};
`;

const ModalPanel = styled.div`
  padding: 1rem 1.5rem;

  width: 100%;
  min-width: 16rem;
  max-width: 22rem;

  position: relative;
  z-index: 1;

  background: ${({ theme }) => theme.core.lightBackground};
  color: ${({ theme }) => theme.core.textColor};
  border: solid 1px ${({ theme }) => theme.core.textColor};
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    0 1rem 3rem -1rem ${props => props.theme.overlay.backgroundColor};
`;

const Header = styled.div`
  font-size: 1rem;
  line-height: 3rem;
  box-shadow: 0 1px 0 ${({ theme }) => theme.core.textColor};
`;

const Body = styled.div`
  margin: 1rem 0;
`;